<template>
  <div v-loading="listContentLoading">
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px;"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button type="primary" size="mini" @click="openDialog(null, 1)">
          添加住宿</el-button
        >
        <el-button type="primary" size="mini" @click="openDialog(null, 2)">
          添加餐食</el-button
        >
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column label="类型" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <div>{{ row.type == 1 ? "住宿" : "餐食" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="标题" align="center" min-width="25%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="说明" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="openIntro(row.title, row.intro)"
            >
              <div>{{ row.intro }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="price"
          label="价格"
          align="center"
          min-width="10%"
        ></el-table-column>

        <el-table-column
          prop="stock"
          label="库存"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="排序" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateItemSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="加火" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.is_fire == 1" style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 已加火</span
              >
              <span v-else style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 未加火</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.is_fire == 1
                    ? updateItemFire(row.id, 0)
                    : updateItemFire(row.id, 1)
                "
              >
                {{ row.is_fire == 1 ? "取消" : "加火" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="deleteItem(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      :title="'添加' + itemTypeName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="addEditFormOnClose"
      width="50%"
    >
      <el-form
        :model="itemInfo"
        :rules="rules"
        label-width="100px"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item :label="itemTypeName+'名称'" prop="title">
          <el-input
            v-model="itemInfo.title"
            maxlength="30"
            show-word-limit
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>

        <el-form-item :label="itemTypeName+'说明'" prop="intro">
          <el-input
            v-model="itemInfo.intro"
            maxlength="120"
            show-word-limit
            placeholder="请输入说明"
          ></el-input>
        </el-form-item>
        <el-form-item :label="itemTypeName+'价格'" prop="price">
          <el-input
            v-model="itemInfo.price"
            type="number"
            :min="0.01"
            :max="10000"
            placeholder="请输入价格"
          ></el-input>
        </el-form-item>

        <el-form-item :label="itemTypeName+'库存'">
          <el-input
            v-model="itemInfo.stock"
            type="number"
            placeholder="请输入库存"
          ></el-input>
        </el-form-item>

        <el-form-item :label="itemTypeName+'排序'">
          <el-input
            v-model="itemInfo.sort"
            type="number"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" @click="addEditFormOnClose()"
            >取 消</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="submitForm('ruleForm')"
            :loading="updateLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getItemList,
  createUpdateItem,
  deleteItem,
  updateItemFire,
  updateItemSort,
} from "@/api/lodging";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        lodging_id: this.$route.query.lodging_id,
      },

      listContentLoading: false,

      itemInfo: {
        item_id: 0,
        lodging_id: this.$route.query.lodging_id,
        type: 1,
        title: "",
        intro: "",
        price: 0,
        stock: 0,
        sort: 0,
      },
      itemTypeName: "住宿",
      updateLoading: false,

      rules: {
        title: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 30, message: "最多不超过30个字", trigger: "blur" },
        ],
        intro: [
          { required: true, message: "请输入说明", trigger: "blur" },
          { min: 1, max: 120, message: "最多不超过120个字", trigger: "blur" },
        ],
        price: [
          { required: true, message: "请输入价格", trigger: "blur" },
          {
            validator(rule, value, callback) {console.log(value, !value, Number(value))
              if (Number(value) <= 0) {
                return callback(new Error("价格无效"));
              }
              setTimeout(() => {
                if (value <= 0 || value > 10000) {
                  callback(new Error("价格无效"));
                } else {
                  callback();
                }
              }, 1000);
            },
          },
        ],
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    openIntro(title, intro) {
      this.$alert(intro, title);
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
    },
    openDialog(row = null, type) {
      this.dialogVisible = true;
      if (row == null) {
        this.itemInfo = {
          item_id: 0,
          lodging_id: this.$route.query.lodging_id,
          type: type,
          title: "",
          intro: "",
          price: "",
          stock: 0,
          sort: 0,
        };
      } else {
        this.itemInfo = {
          item_id: row.id,
          lodging_id: this.$route.query.lodging_id,
          type: row.type,
          title: row.title,
          intro: row.intro,
          price: row.price,
          stock: row.stock,
          sort: row.sort,
        };
      }
      this.itemTypeName = this.itemInfo.type == 2 ? '餐食' : '住宿';
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateLoading = true;
          createUpdateItem(this.itemInfo)
            .then((response) => {
              this.updateLoading = false;
              if (response.code == 1) {
                this.addEditFormOnClose();
                this.$message.success(response.message);
                this.getList();
              }
            })
            .catch((err) => {
              this.updateLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    createUpdateItem() {
      this.updateLoading = true;
      createUpdateItem(this.itemInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.addEditFormOnClose();
            this.$message.success(response.message);
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    getList() {
      this.loading = true;
      getItemList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateItemFire(id, is_fire) {
      updateItemFire({
        item_id: id,
        is_fire: is_fire,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    deleteItem(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteItem({
          item_id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    updateItemSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          updateItemSort({
            item_id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>
